import { render, staticRenderFns } from "./place-info.vue?vue&type=template&id=326534b2&scoped=true&"
import script from "./place-info.vue?vue&type=script&lang=js&"
export * from "./place-info.vue?vue&type=script&lang=js&"
import style0 from "./place-info.vue?vue&type=style&index=0&id=326534b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326534b2",
  null
  
)

export default component.exports